import { splitEntity } from "shelving";
import { JOIN_LEADERBOARD, LEAVE_LEADERBOARD } from "shared/api";
import { AsyncButton, PathButton } from "shared/react";
import { type CreatorEntity, getLeaderboardID } from "shared/schema";
import { callAPI } from "../util/api.js";
import { useItem } from "../util/db.js";
import { USER } from "../util/user.js";

export function LeaderboardMenu({ creator, cid }: { creator: CreatorEntity; cid: string }): React.ReactElement {
	const [type, id] = splitEntity(creator);
	const joined = useItem("leaderboard", getLeaderboardID(creator, cid, "a", USER.data.uid)).value;
	return (
		<nav>
			<PathButton path={`/challenge/${cid}`}>Go to challenge</PathButton>
			<PathButton path={`/${type}/${id}`}>{`Go to ${type}`}</PathButton>
			{joined ? (
				<AsyncButton onClick={() => callAPI(LEAVE_LEADERBOARD, { creator, cid })} mods="confirm">
					Leave leaderboard
				</AsyncButton>
			) : (
				<AsyncButton onClick={() => callAPI(JOIN_LEADERBOARD, { creator, cid })}>Join leaderboard</AsyncButton>
			)}
		</nav>
	);
}
